import {createContext, useContext} from "react";

const ProductsContext = createContext({
    products: [],
    loading: false,
});
export const useProductsContext = () => useContext(ProductsContext);

export default ProductsContext;
